import Vue from 'vue';
import { MutationTree } from 'vuex';
import { ProgressState } from './state';

const mutations: MutationTree<ProgressState> = {
  SET_PROGRESSES(state, entities: ProgressState) {
    if (!entities.progresses) return;

    Object.values(entities.progresses).forEach((progress) => {
      Vue.set(state.progresses, progress.id.toString(), {
        ...state.progresses[progress.id],
        ...progress,
      });
    });
  },
  SET_LOADING_USER_BASE_PROGRESS(state, payload: { isLoading: boolean }) {
    const { isLoading } = payload;
    state.isLoadingBaseProgress = isLoading;
  },
  SET_FIRST_CONTENT_CONSUMED_DATE(state, payload: { date: Date }) {
    state.firstContentConsumedDate = payload.date;
  },
};

export default mutations;
